// Counts uploads that are still in flight across the app, so pages can block navigation until
// they settle. Leaving mid-upload unmounts the field that would receive the result, which drops
// it and leaves the uploaded S3 object unreferenced.
// Components should read this through `useIsUploadInProgress` (hooks/uploads) so they re-render.
let inFlightCount = 0
const listeners = new Set<() => void>()

const notify = () => listeners.forEach(listener => listener())

// returns a release function; calling it more than once is a no-op
export const trackUpload = (): (() => void) => {
    inFlightCount += 1
    notify()

    let released = false
    return () => {
        if (released) return
        released = true
        inFlightCount -= 1
        notify()
    }
}

// point-in-time read for callbacks that outlive a render (history.block, beforeunload)
export const getIsUploadInProgress = (): boolean => inFlightCount > 0

// returns an unsubscribe function
export const subscribeToUploads = (listener: () => void): (() => void) => {
    listeners.add(listener)
    return () => {
        listeners.delete(listener)
    }
}
